<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_1">PART ONE</a></h1><a id="page_1">
<h1 class="part-title"><strong>Regulatory Exemptions Under the Constitution</strong></h1>
<p class="para">Part One addresses the right to religious exemptions from regulation under the Constitution. It is in two subsections — before <em>Employment Division v. Smith</em> in 1990, and after <em>Employment Division v. Smith.</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Part01.vue?3170c87e